import React from 'react';
import { Box, Link, TextBody } from '@ally/metronome-ui';
import { FeatureFlag } from '../../../Utils';
export var bankNumbers = {
    insideUS: '1-877-247-2559',
};
export var investNumbers = {
    insideUSPhone: '1-855-880-2559',
};
export var homeLoanNumbers = {
    insideUS: '1-855-256-2559',
};
export var autoNumbers = {
    insideUS: '1-888-925-2559 ',
};
export var creditCardNumbers = {
    insideUS: '1-888-366-2559',
};
export var CallUsBlock = function (_a) {
    var _b = _a.isWebWrapped, isWebWrapped = _b === void 0 ? false : _b, variation = _a.variation;
    var isAutoNgaEnabled = variation(FeatureFlag.AutoNGA, false);
    var isCardNgaEnabled = variation(FeatureFlag.CardNGA, false);
    return (React.createElement(Box, null,
        React.createElement(Box, { mb: "md" },
            React.createElement(TextBody, { tag: "p", size: "sm", weight: "bold" }, "Bank"),
            isWebWrapped ? (React.createElement(TextBody, { tag: "p", size: "sm" }, bankNumbers.insideUS)) : (React.createElement(Link, { withAllyTM: "Bank - ".concat(bankNumbers.insideUS), text: bankNumbers.insideUS, to: "tel:".concat(bankNumbers.insideUS.replace('-', '')) })),
            React.createElement(TextBody, { tag: "p", size: "sm" }, "We're here 24/7")),
        React.createElement(Box, { mb: "md" },
            React.createElement(TextBody, { tag: "p", size: "sm", weight: "bold" }, "Investments"),
            isWebWrapped ? (React.createElement(TextBody, { tag: "p", size: "sm" }, investNumbers.insideUSPhone)) : (React.createElement(Link, { withAllyTM: "Investments - ".concat(investNumbers.insideUSPhone), text: investNumbers.insideUSPhone, to: "tel:".concat(investNumbers.insideUSPhone.replace('-', '')) })),
            React.createElement(TextBody, { tag: "p", size: "sm" }, "We're here 24/7")),
        isCardNgaEnabled && (React.createElement(Box, { mb: "md" },
            React.createElement(TextBody, { tag: "p", size: "sm", weight: "bold" }, "Credit Card"),
            isWebWrapped ? (React.createElement(TextBody, { tag: "p", size: "sm" }, creditCardNumbers.insideUS)) : (React.createElement(Link, { withAllyTM: "Credit Card - ".concat(creditCardNumbers.insideUS), text: creditCardNumbers.insideUS, to: "tel:".concat(creditCardNumbers.insideUS.replace('-', '')) })),
            React.createElement(TextBody, { tag: "p", size: "sm" }, "We're here 24/7"))),
        React.createElement(Box, { mb: "md" },
            React.createElement(TextBody, { tag: "p", size: "sm", weight: "bold" }, "Home Loans"),
            isWebWrapped ? (React.createElement(TextBody, { tag: "p", size: "sm" }, homeLoanNumbers.insideUS)) : (React.createElement(Link, { withAllyTM: "Home Loans - ".concat(homeLoanNumbers.insideUS), text: homeLoanNumbers.insideUS, to: "tel:".concat(homeLoanNumbers.insideUS.replace('-', '')) })),
            React.createElement(TextBody, { tag: "p", size: "sm" },
                "Mon \u2013 Fri 8:30 am \u2013 8 pm ET ",
                React.createElement("br", null),
                "Sat 8:30 am \u2013 1 pm ET")),
        isAutoNgaEnabled && (React.createElement(Box, { mb: "md" },
            React.createElement(TextBody, { tag: "p", size: "sm", weight: "bold" }, "Auto"),
            isWebWrapped ? (React.createElement(TextBody, { tag: "p", size: "sm" }, autoNumbers.insideUS)) : (React.createElement(Link, { withAllyTM: "Auto - ".concat(autoNumbers.insideUS), text: autoNumbers.insideUS, to: "tel:".concat(autoNumbers.insideUS.replace('-', '')) })),
            React.createElement(TextBody, { tag: "p", size: "sm" },
                "Mon \u2013 Fri 8 am \u2013 11 pm ET ",
                React.createElement("br", null),
                "Sat 9 am \u2013 7 pm ET")))));
};
//# sourceMappingURL=CallUsBlock.js.map